import { Switch, Route, withRouter } from 'react-router-dom';
import Ticket from '@nkr/views/ticketing/ticket';
import NewEmail from '@nkr/views/ticketing/ticket/admin/new-email';
import NewTicket from '@nkr/views/ticketing/ticket/admin/new-ticket';
import Tickets from '@nkr/views/ticketing/tickets';
import TicketCannedResponseList from '@nkr/views/ticketing/canned-response/list';
import TicketCannedAddEdit from '@nkr/views/ticketing/canned-response/add-edit';
import TicketGroupList from '@nkr/views/ticketing/ticket-groups';
import NotFound from '../not-found';

const TicketingRoutes = (params) => {
    let url = params.url;

    return (
        <Switch>
            <Route path={`${url}/tickets`} render={() => <Tickets isAdmin={true} />} />
            <Route path={`${url}/ticket/new`} render={() => <NewTicket />} />
            <Route path={`${url}/ticket/compose-email`} render={() => <NewEmail />} />
            <Route path={`${url}/ticket/:id`} render={({ match: { params: subParams } }) => <Ticket id={subParams.id} />} />
            <Route path={`${url}/ticket-groups`} render={() => <TicketGroupList />} />
            <Route path={`${url}/canned-responses`} render={() => <TicketCannedResponseList />} />
            <Route path={`${url}/canned-response/new`} render={() => <TicketCannedAddEdit id={0} />} />
            <Route path={`${url}/canned-response/:id`} render={({ match: { params: subParams } }) => <TicketCannedAddEdit id={subParams.id} />} />
            <Route path={`${url}`} component={NotFound} />
        </Switch>
    );
}

export default withRouter(TicketingRoutes);